"use strict";

var _defineProperty = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var formatFieldDataListItem_1 = require("./formatFieldDataListItem");

exports.formatFieldData = function (type, data, _ref, options) {
  var fieldSchema = _ref.fieldSchema,
      schema = _ref.schema,
      initialData = _ref.initialData;
  var nextData = formatFieldDataListItem_1.formatFieldDataListItem(type, data, {
    fieldSchema: fieldSchema,
    schema: schema,
    initialData: initialData
  }, options);
  return nextData ? _defineProperty({}, nextData.type, nextData.data) : null;
};